import { render, staticRenderFns } from "./merchantReview.vue?vue&type=template&id=df0c037a&scoped=true"
import script from "./merchantReview.vue?vue&type=script&lang=js"
export * from "./merchantReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0c037a",
  null
  
)

export default component.exports